import React from "react";
import Shared from "../../../../components/ReUseAbleComponents/Shared";
import { Link } from "react-router-dom";
import ReactSelect from "react-select";
import product1xspng from "../../../../assets/images/product-1-xs.png";
import product2xspng from "../../../../assets/images/product-2-xs.png";
import product3xspng from "../../../../assets/images/product-3-xs.png";
import product4xspng from "../../../../assets/images/product-4-xs.png";
import product5xspng from "../../../../assets/images/product-5-xs.png";

function SubmitTicket2(props) {
  const categories = [
    { id: 1, image: product1xspng, name: "Product 1" },
    { id: 2, image: product2xspng, name: "Product 2" },
    { id: 3, image: product3xspng, name: "Product 3" },
    { id: 4, image: product4xspng, name: "Product 4" },
    { id: 5, image: product5xspng, name: "Product 5" },
  ];
  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        backgroundColor: isFocused ? "#2b72e6" : "white",
        color: isFocused && "#ffff",
      };
    },
  };

  return (
    <>
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <div className="dx-box dx-box-decorated">
                <div className="dx-box-content">
                  <h2 className="h6 mb-6">Submit a Ticket</h2>

                  <ul className="dx-breadcrumbs text-left dx-breadcrumbs-dark mnb-6 fs-14">
                    <li>
                      <Link to="/help-center">Support Home</Link>
                    </li>
                    <li>
                      <Link to="/ticket">Ticket System</Link>
                    </li>
                    <li>Submit Ticket</li>
                  </ul>
                </div>
                <div className="dx-separator"></div>
                <form action="#" className="dx-form">
                  <div className="dx-box-content">
                    <div className="dx-form-group">
                      <label for="select-product" className="mnt-7">
                        Select Product
                      </label>
                      <ReactSelect
                        className="form-control dx-select-ticket"
                        options={categories}
                        styles={customStyles}
                        placeholder="Choose one..."
                        formatOptionLabel={(category) => (
                          <div className="country-option">
                            <img src={category.image} alt="cat-logo" />
                            <span>{category.name}</span>
                          </div>
                        )}
                      />
                    </div>
                    <div className="dx-form-group">
                      <div
                        className="alert dx-alert dx-alert-primary"
                        role="alert"
                      >
                        * Your License. Purchase Date: 5 Nov 2018
                      </div>
                    </div>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-box-content">
                    <div className="dx-form-group">
                      <label for="subject" className="mnt-7">
                        Subject
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-style-2"
                        id="subject"
                        placeholder="Enter Subject"
                      />
                    </div>
                    <div className="dx-form-group">
                      <label className="mnt-7">Description</label>
                      <div className="dx-editor-quill">
                        <div
                          className="dx-editor"
                          data-editor-height="150"
                          data-editor-maxHeight="250"
                        ></div>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="dx-box-content pt-0">
                  <form
                    className="dx-dropzone"
                    action="#"
                    data-dropzone-maxMB="5"
                    data-dropzone-maxFiles="5"
                  >
                    <div className="dz-message">
                      <div className="dx-dropzone-icon">
                        <span className="icon pe-7s-cloud-upload"></span>
                      </div>
                      <div className="h6 dx-dropzone-title">
                        Drop files here or click to upload
                      </div>
                      <div className="dx-dropzone-text">
                        <p className="mnb-5 mnt-1">
                          You can upload up to 5 files (maximum 5 MB each) of
                          the following types: .jpg, .jpeg, .png, .zip.
                        </p>
                      </div>
                    </div>
                  </form>
                  <div className="row justify-content-between vertical-gap dx-dropzone-attachment">
                    <div className="col-auto dx-dropzone-attachment-add">
                      <label className="mb-0 mnt-7">
                        <span className="icon fas fa-paperclip mr-10"></span>
                        <span>Add Attachment</span>
                      </label>
                    </div>
                    <div className="col-auto dx-dropzone-attachment-btn">
                      <button
                        className="dx-btn dx-btn-lg"
                        type="button"
                        name="button"
                      >
                        Submit a ticket
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubmitTicket2;
